var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { getInfoSetsCreatedsInLastThirtyDays, } from '@/clients/admin';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
let InfosetsTableTab = class InfosetsTableTab extends Vue {
    constructor() {
        super(...arguments);
        this.infosets = [];
    }
    mounted() {
        this.fetchInfosets();
    }
    onDaysChange() {
        this.fetchInfosets();
    }
    async fetchInfosets() {
        const accountId = this.$store.getters['admin/get_selected_account'];
        const response = await getInfoSetsCreatedsInLastThirtyDays(accountId, this.days);
        if (response && response.status == 200 && response.data) {
            this.infosets = response.data;
        }
    }
    is_validation_done(validation_status) {
        if (validation_status == 'not initialized')
            return 'Não';
        return 'Sim';
    }
    infoset_url(infoset_id) {
        return window.location.origin + '/infosets/' + infoset_id;
    }
    search_url(search_id) {
        return window.location.origin + '/search/' + search_id;
    }
};
__decorate([
    Prop({ type: Number, default: 30 })
], InfosetsTableTab.prototype, "days", void 0);
__decorate([
    Watch('days')
], InfosetsTableTab.prototype, "onDaysChange", null);
InfosetsTableTab = __decorate([
    Component({})
], InfosetsTableTab);
export default InfosetsTableTab;
